       
<template>
  <div class="basetime_container">
    <div>{{ value.title }}</div>
    <div>
      <span class="basetime_minute">{{ value.subTitle }}</span>
    </div>
  </div>
</template>
<script>
import FormatTimeViewModel from "../../components/viewmodels/FormatTimeViewModel.js";

export default {
  name: "base-time-title",
  props: {
    value: {
      type: Object,
      default: function() {
        return new FormatTimeViewModel();
      }
    }
  }
};
</script>
<style scoped>
.basetime_container {
  display: flex;
  align-items: center;
}
.basetime_minute {
  font-size: 7pt;
  vertical-align: top;
  line-height: 14px;
}
</style>